import { Sample } from '../../@types/samples/types';

/** The batchable methodologies. 'lambda' is Brooks-Corey in the UI;
 * 'water-oil' / 'gas-oil' are the relative-permeability (Kr) analyses. */
export type AnalysisMethod = 'liao' | 'lambda' | 'water-oil' | 'gas-oil';

export const METHOD_LABELS: Record<AnalysisMethod, string> = {
  liao: 'Liao',
  lambda: 'Brooks-Corey',
  'water-oil': 'Water-Oil Kr',
  'gas-oil': 'Gas-Oil Kr',
};

export const ANALYSIS_METHODS: AnalysisMethod[] = [
  'liao',
  'lambda',
  'water-oil',
  'gas-oil',
];

/** The relative-permeability methodologies (share the Kr run-mode toggle). */
export const isKrMethod = (
  method: AnalysisMethod
): method is 'water-oil' | 'gas-oil' =>
  method === 'water-oil' || method === 'gas-oil';

/** Kr batch run mode: full auto-refinement (default) or lab baseline only. */
export type KrRunMode = 'auto' | 'lab';

export const KR_RUN_MODE_LABELS: Record<KrRunMode, string> = {
  auto: 'Auto refinement',
  lab: 'Lab baseline',
};

/** Lifecycle of one sample inside a batch run. */
export type SampleRunStatus =
  | 'pending'
  | 'running'
  | 'valid'
  | 'warning'
  | 'failed';

export interface SampleRunResult {
  sampleUid: string;
  status: SampleRunStatus;
  /** Human-readable reasons behind a warning/failed status. */
  reasons: string[];
  /** Updated sample returned by the backend (absent when the request failed). */
  sample?: Sample;
  /** Session-only acceptance flag toggled by the user. */
  reviewed: boolean;
  /** True once this preview result has been persisted to the backend. */
  saved: boolean;
}

export type StatusFilter = 'all' | 'valid' | 'warning' | 'failed' | 'unreviewed';

export type BatchStatus = 'idle' | 'running' | 'done' | 'cancelled';

export interface BatchProgress {
  done: number;
  total: number;
}
